import { Card, CardContent } from "@/core/components/ui/card";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Top3RankingProps extends React.ComponentPropsWithoutRef<typeof Card> {
  data: { position: number; name: string; value: number }[];
  isLoading?: boolean;
}

export function Top3Ranking({ data, isLoading, ...props }: Top3RankingProps) {
  const [translate] = useTranslation(["dashboard"]);

  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(274px,1fr))] gap-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <Card key={index} className="border-none" {...props}>
          <CardContent className="flex flex-col justify-center items-center p-6">
            <span className="text-[40px]">
              {index + 1 === 1 ? "🥇" : index + 1 === 2 ? "🥈" : "🥉"}
            </span>
            {isLoading ? (
              <div className="flex justify-center items-center">
                <Loader2 className="w-8 h-8 animate-spin" />
              </div>
            ) : (
              <>
                <span className="text-2xl font-medium">
                  {data[index]?.name ?? "-"}
                </span>
                <span className="text-base text-gray-500">
                  {data[index]?.value ?? 0}{" "}
                  {translate("dashboard-reservations")}
                </span>
              </>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
